import { createSelector } from 'reselect';
import get from 'lodash/get';
import { SCOPE } from './types';

const selector = state => get(state, SCOPE);

export const thresholdConfigsSelector = createSelector(selector, state => {
  return state.thresholds
});

export const isEditableFlagSelector = createSelector(selector, state => (state.isBeingEdited));

export const createNewClickedSelector = createSelector(selector, state => (state.isCreateNewSelected));

export const selectedThresholdConfigSelector = createSelector(selector, state => (state.selectedConfig));

export const thresholdsListInitializingSelector = createSelector(selector, state => (state.isInitializing));

export const loadingSelector = createSelector(selector,
  state => ({
    loading: state.isFetching,
    showError: state.errorCode !== 0,
    errorMsg: state.errorMsg,
  }));

export default selector;
